import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

export interface BreadcrumbSegment {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  segments: BreadcrumbSegment[];
}

/** Consistent "Operations > Work Queue > Review Workspace" trail for OPS
 * workspace pages — generalizes the inline back-link pattern already used
 * on pages like EmailGatewayPage.tsx to an arbitrary number of segments. */
export function Breadcrumb({ segments }: BreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground"
    >
      {segments.map((segment, i) => {
        const isLast = i === segments.length - 1;
        return (
          <span key={`${segment.label}-${i}`} className="flex items-center gap-2">
            {i === 0 && <FontAwesomeIcon icon={faChevronLeft} className="h-2.5 w-2.5" />}
            {!isLast && segment.to ? (
              <Link to={segment.to} className="transition-colors hover:text-foreground">
                {segment.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground' : undefined}>{segment.label}</span>
            )}
            {!isLast && <span aria-hidden="true">/</span>}
          </span>
        );
      })}
    </nav>
  );
}
